import { execute } from '@/api/execute'
import { GET, PUT } from '@/api/types'
import { addQueryParams } from '@/util/index.js'

const ENDPOINT = 'schedule/loadings'

export default {
  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/`, params))
  },

  getById (id) {
    return execute(GET, `${ENDPOINT}/${id}/`)
  },

  updateById (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/`, payload)
  }
}
